<template>
  <abf-container>
    <v-layout>
      <v-flex xs3 sm4>
        <v-card>
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>people</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Users</h4>
            </div>
          </v-card-title>
          <v-list three-line dense class="transparent">
            <template v-for="user in users">
              <v-list-item
                v-if="UserHasRole('Platform') || UserId === user.id"
                :key="user.id"
                @click="selectUser(user)"
                :class="{ 'primary--text': isActiveUser(user.id) }"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary">{{ user.email }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <strong>Last login: </strong>
                    <span v-if="user.last_logged_in_at">
                      {{ user.last_logged_in_at && user.last_logged_in_at | moment('calendar') }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${user.id}`" class="ml-3 mr-3"></v-divider>
            </template>
            <v-list-item v-if="UserHasRole('Platform')">
              <v-list-item-content>
                <v-btn color="accent" @click="showNewUser = true">Add new user</v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs9 sm8>
        <v-card>
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>person</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">User Details</h4>
            </div>
          </v-card-title>
          <v-toolbar flat color="white" class="pl-3">
            <v-toolbar-title>{{ selectedUser.full_name }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.first_name" label="First name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.last_name" label="Last name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.email" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.phone" label="Phone"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-switch v-model="updateUser.referral_summary_signup" label="Receive Referral Summary"></v-switch>
                  </v-flex>
                  <v-flex v-for="role in updateUser.roles" :key="role">
                    <v-switch
                      v-if="role === 'Provider'"
                      v-model="updateUser.funder_newsletter_signup"
                      label="Receive Funder Newsletter"
                    ></v-switch>
                    <v-switch
                      v-if="role === 'Partner'"
                      v-model="updateUser.partner_newsletter_signup"
                      label="Receive Partner Newsletter"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="!UserHasRole('Platform')">
                    <v-text-field
                      hint="At least 8 characters"
                      min="8"
                      :append-icon="p1 ? 'visibility' : 'visibility_off'"
                      @click:append="() => (p1 = !p1)"
                      :type="p1 ? 'password' : 'text'"
                      counter
                      v-model="updateUser.password"
                      label="Reset password"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="!UserHasRole('Platform')">
                    <v-text-field
                      hint="At least 8 characters"
                      min="8"
                      :append-icon="p2 ? 'visibility' : 'visibility_off'"
                      @click:append="() => (p2 = !p2)"
                      :type="p2 ? 'password' : 'text'"
                      counter
                      v-model="updateUser.password_confirm"
                      :error-messages="passwordErrorMessage"
                      label="Confirm password"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions class="ml-4 mr-4 pb-4">
            <v-btn v-if="UserHasRole('Platform')" color="accent" text @click="sendWelcomeMessage">
              Send Welcome Email
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="accent" :disabled="!valid" @click="updateSelectedUser()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <new-user-dialog
      :show.sync="showNewUser"
      :selectedBusinessId="SelectedPartner.id"
      :selectedBusinessName="SelectedPartner.name"
      @success="refreshPartner"
    ></new-user-dialog>
  </abf-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import NewUserDialog from '../Funders/NewUserDialog';
import AbfContainer from '../../Abf/AbfContainer';

export default {
  components: { AbfContainer, NewUserDialog },
  name: 'partner-users',
  data: () => ({
    showNewUser: false,
    selectedUser: {},
    updateUser: {},
    p1: true,
    p2: true,
    valid: true
  }),
  computed: {
    ...mapGetters(['SelectedPartner', 'UILeftDrawer', 'PlatformUser', 'UserHasRole', 'UserId', 'UserEmail']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    passwordErrorMessage() {
      return this.updateUser.password === this.updateUser.password_confirm
        ? []
        : ["The passwords you entered don't match"];
    },
    users() {
      return this.UserHasRole('Platform')
        ? this.SelectedPartner.users
        : _.filter(this.SelectedPartner.users, user => user.email === this.UserEmail);
    }
  },
  methods: {
    ...mapActions([
      'getReferrals',
      'setReferrerId',
      'updatePartnerUser',
      'sendPartnerWelcomeMessage',
      'addNotification',
      'selectPartner'
    ]),
    selectUser: function(user) {
      this.selectedUser = user;
      this.updateUser = _.clone(user);
    },
    isActiveUser(id) {
      return id === this.selectedUser.id;
    },
    updateSelectedUser() {
      const updates = this.diff(this.updateUser, this.selectedUser);
      if (_.isEmpty(updates)) {
        return;
      }
      if (updates.password !== null && updates.password !== updates.password_confirm) {
        this.addNotification({
          text: `Your passwords must match`,
          colour: 'red'
        });
        return;
      }
      this.updatePartnerUser({ id: this.selectedUser.id, updates }).then(() => {
        this.addNotification({
          text: `${this.selectedUser.full_name} user details updated`
        });
      });
    },
    sendWelcomeMessage() {
      this.sendPartnerWelcomeMessage(this.selectedUser.id).then(() => {
        this.addNotification({
          text: `${this.selectedUser.full_name}: password reset and welcome message sent`
        });
      });
    },
    refreshPartner() {
      this.addNotification({
        text: `User added`
      });
      this.selectPartner(this.SelectedPartner.id);
    },
    diff(object, base) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }

      return changes(object, base);
    }
  },
  watch: {
    SelectedPartner: {
      immediate: true,
      handler() {
        this.selectedUser = this.users[0];
        this.updateUser = _.clone(this.users[0]);
      }
    }
  }
};
</script>
